/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingBalanceGetResponse {
    getFixupPrototypeFunction() { return MasterAccountBillingBalanceGetResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingBalanceGetResponse>): MasterAccountBillingBalanceGetResponse {
        let obj = Object.assign(new MasterAccountBillingBalanceGetResponse(), model);
        MasterAccountBillingBalanceGetResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingBalanceGetResponse>): MasterAccountBillingBalanceGetResponse {
        if (!model) return null;
        return MasterAccountBillingBalanceGetResponse.newInstance(<MasterAccountBillingBalanceGetResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingBalanceGetResponse) {
        if (!obj) return;

        models.MasterAccountBillingBalanceGetResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingBalanceGetResponse): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingBalanceGetResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.current_balance === undefined) {
            this.current_balance = 0;
        }
    }

    /**
     * Current balance for the master account.
     */
    current_balance: number;

}
